export default __webpack_public_path__ + "static/media/mirolyub_m.da52c7c0.jpg";